import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { ColorMode } from 'actions/agent_preferences/lib/channel_color_constants';

export default class SetChannelColorMode {
  constructor(context) {
    this.context = context;
  }

  run({ mode }) {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.setCustomizeChannelColors(mode === ColorMode.PER_CHANNEL);
    setAgentPreferences(this.context, preferences);
  }
}
